import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/utils'

export interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-10 text-muted-foreground', className)}>
      {Icon && <Icon className="w-10 h-10 mb-2" aria-hidden="true" />}
      <p className="text-sm font-medium text-foreground">{title}</p>
      {description && <p className="text-sm mt-1">{description}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  )
}
